export const MCP_CALLS_UNCOUNTED = 'not counted here';

export type McpCallMetricRow = {
  total_mcp_calls?: number | null;
  last_mcp_call?: string | null;
  last_mcp_tool?: string | null;
  mcp_calls_counted?: boolean;
};

export function mcpCallsAreCounted(ep: McpCallMetricRow): boolean {
  if (ep.mcp_calls_counted === false) return false;
  if (ep.mcp_calls_counted === true) return true;
  return ep.total_mcp_calls != null;
}

export function presentMcpCallCount(ep: McpCallMetricRow): string {
  if (!mcpCallsAreCounted(ep) || ep.total_mcp_calls == null) return MCP_CALLS_UNCOUNTED;
  return Number(ep.total_mcp_calls).toLocaleString();
}

export function presentMcpLastCallLabel(ep: McpCallMetricRow): string {
  if (!mcpCallsAreCounted(ep)) return MCP_CALLS_UNCOUNTED;
  if (!ep.last_mcp_call) return 'Never';
  const ts = new Date(ep.last_mcp_call);
  if (Number.isNaN(ts.getTime())) return MCP_CALLS_UNCOUNTED;
  return ts.toLocaleString();
}

export function hasMcpLastCallStamp(ep: McpCallMetricRow): boolean {
  if (!mcpCallsAreCounted(ep) || !ep.last_mcp_call) return false;
  return !Number.isNaN(new Date(ep.last_mcp_call).getTime());
}
